/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 17:02:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-07 13:34:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/FlashSaleEdit/Summary/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { RemindUnitProps } from '@/src/types/common';
import { DiscountType } from '@/src/types/common/discount';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  i18nGet,
  replaceI18nVariables,
  handleOnFormatCurrentSCTimeAndDate,
} from 'src/tools/tools';
import { EnumStatus } from 'src/types/common/discount';
import { useSalesChannelIsMiniProgram } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import SummaryComponent from '../../../Components/Summary';
import css from '../css.module.less';

const getFrequencyI18nKey = (frequencyUnit) => {
  const i18nKeyMapping = {
    [RemindUnitProps.Days]: 'general.day(s)',
    [RemindUnitProps.RollingDays]: 'general.day(s)',
    [RemindUnitProps.Hours]: 'general.hour(s)',
  };
  return i18nKeyMapping[frequencyUnit];
};
const Summary = ({ activeTime, status }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const isMini = useSalesChannelIsMiniProgram();

  const { beginDate, beginTime, endDate, endTime } = activeTime;
  const renderSummaryData = (getFieldsValue) => {
    const { remindUnit, numOfRemindUnits, flashSaleGroups, currencyCode } =
      getFieldsValue([
        'remindUnit',
        'numOfRemindUnits',
        'flashSaleGroups',
        'currencyCode',
      ]);
    const groupsSummary = flashSaleGroups
      .map((group, index) => {
        const { flashSaleDiscount } = group;
        const { discountType, percentageOff, reductionAmount } =
          flashSaleDiscount;
        const text =
          percentageOff || reductionAmount
            ? discountType == DiscountType.PercentageOff
              ? replaceI18nVariables(
                  getI18n('salesChannelFlashSale.summary.group1'),
                  index + 1,
                  percentageOff,
                )
              : replaceI18nVariables(
                  getI18n('salesChannelFlashSale.summary.group2'),
                  index + 1,
                  reductionAmount,
                )
            : '';
        return text;
      })
      .filter((o) => o !== '');
    return [
      ...(currencyCode && !isMini
        ? [`${getI18n('general.applicableCurrency')} ${currencyCode}`]
        : []),
      ...(beginDate
        ? [
            `${replaceI18nVariables(
              getI18n('salesChannelDirectDiscount.summary.validfrom'),
              handleOnFormatCurrentSCTimeAndDate(`${beginDate} ${beginTime}`),
            )} ${getI18n('general.to')} ${handleOnFormatCurrentSCTimeAndDate(
              `${endDate} ${endTime}`,
            )}`,
          ]
        : []),
      ...(numOfRemindUnits
        ? [
            replaceI18nVariables(
              getI18n('salesChannelFlashSale.summary.reminder'),
              numOfRemindUnits,
              getI18n(getFrequencyI18nKey(remindUnit)),
            ),
          ]
        : []),

      ...groupsSummary,
    ];
  };

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.sectionContainer}
        title={getI18n('general.summary')}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue, getFieldsValue }) => (
            <SummaryComponent
              name={getFieldValue('name')}
              status={status || EnumStatus.Draft}
              summaryContent={renderSummaryData(getFieldsValue)}
            />
          )}
        </Form.Item>
      </SectionWrapper>
    </div>
  );
};

export default Summary;
